import React, { memo, Suspense, useCallback, useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom";
import { getTrans as T } from '../../../../Shared/Language';
import { deleteFeedPost, getFeed, getFeedCount, getReportPost, postMarkFeatured, postMarkUnFeatured } from "../Services/DashboardServices";
import { TostMsg } from "../../../../App";
import moment from 'moment';
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  LazyImage as OriginalLazyImage,
  LazySliderImage as OriginalLazySliderImage,
  LazySliderVideo as OriginalLazySliderVideo,
} from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding"; import { useFormik } from "formik";
import * as Yup from "yup";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import FollowUpSuggestions from "../FollowUpSuggestions/FollowUpSuggestions";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { FeedSliderCarousel } from "../DashboardFeed/FeedSliderCarousel";
import { DashboardPopularPost } from "../PostsCommonSlider/PopularPostSlider";
import { FeedDetailComment } from "./FeedDetailComment";
import { DashboardFeatureAndPopularPost } from "../PostsCommonSlider/FeaturePostSlider";
import Skeleton from "react-loading-skeleton";
import FeedPost from "../DashboardFeed/FeedPost";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import { useSelector } from "react-redux";

const ComponentLoader = React.lazy(() => import("../../../../Shared/Sidebar/ComponentLoader"));
let DeleteId;
let MakeFeaturedFeedId;
let UserEmpId;
let GifKey = process.env.GIFAPIKEY;
let isFeaturedType;

const FeedDetails = memo(() => {
  const [Isloading, setIsloading] = useState(true);
  const [IsLoadingCount, setIsLoadingCount] = useState(false);
  let history = useHistory();
  const [feedLst, setFeelLst] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let { FeedGUID } = useParams();
  const toster = useContext(TostMsg);
  const [showReportPostModal, setShowReportPostModal] = useState(false);
  const [feedId, setFeedId] = useState(0);
  const [uploadedPostImages, setUploadedPostImages] = useState([]);
  const [postFile, setPostFile] = useState(null);
  const [feedEmployeeDetails, setFeedEmployeeDetails] = useState([]);
  const [feedCount, setFeedCount] = useState([]);
  const defaultImage = '/images/placeholder_profile.png';
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [feedDetailEdit, setFeedDetailEdit] = useState(false);
  const [feedDetailReport, setFeedDetailReport] = useState(false);
  const [feedDetailDelete, setFeedDetailDelete] = useState(false);
  const [feedDetailFeatured, setFeedDetailFeatured] = useState(false);
  const [showPostModal, setShowPostModal] = useState(true);
  const LazyImage = React.memo(OriginalLazyImage);
  const LazySliderImage = React.memo(OriginalLazySliderImage);
  const LazySliderVideo = React.memo(OriginalLazySliderVideo);


  useEffect(() => {
    GetFeed();
    permissionFeedDetailGranted();
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [FeedGUID]);



  const handleClickOutside = (event) => {
    if (!event.target.closest('.dropdown')) {
      setShowPostModal(false);
    }
  };

  const handleEvent = (name) => {
    if (name == 'success') {
      GetFeed();
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleLikeEvent = (name) => {
    if (name == 'success') {
      // FeedLikeList();
    }
  };

  const handalClosePopup = () => {
    setShowReportPostModal(false);
    reportPostForm.resetForm();
    setUploadedPostImages([]);
  };

  function myFunction() {
    var x = document.getElementById("myDIV2");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
    if (showPostModal == false) {
      x.style.display = "none";
      setShowPostModal(true);
    }
  }

  //Get Feed List
  async function GetFeed() {
    setIsloading(true);
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      EmpGUID: '',
      FeedId: 0,//Number(FeedId),
      pageNumber: 1,
      IsFeatured: 0,
      pageSize: 1,
      LoggedInUserId: userDetails?.EmpId,
      FeedGUID: FeedGUID,
    }
    try {
      let Feedlst = await getFeed(body);
      setFeelLst(Feedlst.Data);
      UserEmpId = Feedlst.Data[0]?.CreatedBy
      if (UserEmpId) {
        GetFeedCount();
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.DashboardFeed);
    } finally {
      setIsloading(false);
    }
  }


  function markFeatured(feedId, type) {
    MakeFeaturedFeedId = feedId;
    isFeaturedType = type
  }

  async function PostMarkFeatured() {
    setIsloading(true);
    const body = {
      PostId: MakeFeaturedFeedId
    }
    try {
      await postMarkFeatured(body);
      history?.push('/Feed/Featured');
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MakeFeatured);
    }
  }


  useEffect(() => {
    if (feedLst.length > 0) {
      fetchEmployeeData()
    }
  }, [feedLst]);

  const fetchEmployeeData = useCallback(async () => {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: 0,
             IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let FeedEmpDetails = employeesList?.Data?.filter((el) => el?.EmpId === feedLst[0]?.ModifiedBy);
      setFeedEmployeeDetails(FeedEmpDetails[0]);
    } catch (error) {
      setIsloading(false);
    }
  }, [feedLst]);

  function deleteItem(deleteId) {
    DeleteId = deleteId;
  }
  //Delete the Feed.
  async function DeleteFeedPost() {
    if (DeleteId) {
      let body = {
        Id: DeleteId,
      };
      setIsloading(true);
      try {
        history.push('/Dashboard');
        await deleteFeedPost(body);
        document.getElementById("delete-post").click();
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        return false;
      }
    }
  }

  const reportPostValidation = Yup.object().shape({
    subject: Yup.string().required("Subject name is required"),
    desc: Yup.string().required("Title desc is required"),
    url: Yup.string(),
  });
  const reportPostForm = useFormik({
    initialValues: {
      subject: "",
      desc: "",
      url: "",
    },
    validationSchema: reportPostValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      data.PostId = feedId ?? 0;
      data.EmpId = userDetails?.EmpId;
      let reportPostList = await getReportPost(data);
      try {
        if (reportPostList) {
          reportPostForm.resetForm();
          setUploadedPostImages([]);
          toster.current.success("Report post successfully");
          document.querySelector("#report-img .btn-close")?.click();
          handalClosePopup();
          setShowReportPostModal(false);
          setIsloading(false);
        }
      } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    },
  });

  const handleFilePostChange = useCallback(async (event) => {
    const selectedFile = await event.target.files[0];
    setPostFile(selectedFile);
  }, [])

  useEffect(() => {
    if (postFile) {
      uploadPostDocFile();
    }
  }, [postFile]);

  async function uploadPostDocFile() {
    if (postFile) {
      setIsloading(true);
      const formData = new FormData();
      formData.append("files", postFile);
       let params = {
        UploadType: UploadFile_KEYS?.Feed,
        RefId: feedLst?.Id ?? 0,
      }
      const response = await await uploadDoc(params, formData);
      const data = await response;
      const postFormData = data?.Data[0];
      setUploadedPostImages(data?.Data[0]);
      reportPostForm.setFieldValue("url", postFormData);
      setIsloading(false);
    } else {
      toster.current.warn("No file selected");
      setIsloading(false);
    }
  }

  const handleResponseFromB = (response) => {
    if (response) {
      GetFeed();
      setFeelLst([]);
    }
  };

  const handleDeleteImage = (uploadedPostImages) => {
    setUploadedPostImages([]);
  }
  const [editFeedLst, setEditFeedLst] = useState(null);
  const EditFeedLst = (feedLst) => {
    setTimeout(() => setEditFeedLst(feedLst), 0);
  }

  const GetFeedCount = async () => {
    setIsLoadingCount(true);
    const body = {
      EmpId: UserEmpId,
      OrgId: userDetails?.OrgId
    }
    try {
      let feedCountList = await getFeedCount(body);
      setFeedCount(feedCountList?.Data[0]);
      setIsLoadingCount(false);
    } catch (error) {
      setIsLoadingCount(false);
      toster.current.error(ERROR_LIST?.FeedCount);
    }
  }

  const permissionFeedDetailGranted = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Feed.Edit") {
        setFeedDetailEdit(true);
      } else if (UserPermission.PermissionName == "Feed.Report") {
        setFeedDetailReport(true);
      } else if (UserPermission.PermissionName == "Feed.Delete") {
        setFeedDetailDelete(true);
      } else if (UserPermission.PermissionName == "Feed.Featured") {
        setFeedDetailFeatured(true);
      }
    });
  };

  function markUnFeatured(feedId, type) {
    MakeFeaturedFeedId = feedId;
    isFeaturedType = type;
  }

  async function PostMarkUnFeatured() {
    setIsloading(true);
    const body = {
      PostId: MakeFeaturedFeedId,
    };
    try {
      await postMarkUnFeatured(body);
      setFeelLst([]);
      GetFeed(true);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MakeFeatured);
    }
  }

  const FeedCarouselTemplate = useCallback((media) => {
    const isVideo = media[0]?.MediaPath?.endsWith(".mp4") || media[0]?.MediaPath?.toLowerCase()?.endsWith(".mov");
    const mediaSrc = media[0]?.MediaPath || defaultImage;
    return isVideo ? (
      <LazySliderVideo
        id="videoElement"
        src={mediaSrc}
        playsInline
        // muted
        controls
      />
    ) : (
      <LazySliderImage
        style={{ borderRadius: '0 !important' }}
        src={mediaSrc}
        onError={handleImageError}
        alt="Description of the image"
      />
    );
  }, []);

  return (
    <div className="position-relation">
      <FeedPost returnResponce={handleResponseFromB} editFeedLst={editFeedLst} />
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-xl-3 first">
            <div className="col-xl-12 owl-co">
              <div className="">
                <div className="v">
                  <div className="profile-side-div">
                    <div className="profile card card-body px-2 pt-3 pb-0">
                      <div className="profile-head">
                        <div className="photo-content">
                          <div className="cover-photo"></div>
                        </div>
                        <Link to={`/Profile/${feedLst[0]?.PostedByGUID}`}>
                          <div className="profile-info">
                            <div className="profile-photo">
                              <img src={feedLst[0]?.ProfilePic || defaultImage} onError={handleImageError}
                                className="img-fluid rounded-circle" alt={feedLst[0]?.PostedBy} />
                            </div>
                            <div className="profile-details text-center mt-3" style={{ display: 'block' }}>
                              <div className="profile-name px-3 pt-0 profile-names">
                                <h4 className="text-primary mb-2">{feedLst[0]?.PostedBy}</h4>
                                {/* <p>{feedEmployeeDetails?.AssociatedSince}</p> */}
                                <a>View Profile</a>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {IsLoadingCount ? (
              <Skeleton height="30%" width="100%" />
            ) : (
              <div className="col-xl-12 owl-co">
                <div className="post-statistic">
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to="/Dashboard"><h5>{feedCount?.TotalPostCount}</h5>
                      <p>Total Posts</p></Link>
                  </div>
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to="/Feed/Featured"><h5>{feedCount?.FeaturedPostCount}</h5>
                      <p>Featured Posts</p></Link>
                  </div>
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to="/Feed/Popular"><h5>{feedCount?.PopularPostCount}</h5>
                      <p>Popular Posts</p></Link>
                  </div>
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to={`/Feed/User/${feedLst[0]?.PostedByGUID}`}><h5>{feedCount?.UserPostCount}</h5>
                      <p>{feedLst[0]?.PostedBy?.split(' ')[0]}'s Posts</p></Link>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="col-xl-6 second">
            {Isloading ? (
              <Skeleton height={270} width="100%" />
            ) : (<div className="row g-3">
              {feedLst?.slice(0, 1)?.map((feedlst, index) => (
                <div key={index} className="col-xl-12" id='upcomings'>
                  <div className="card" style={{ "background": "none", "boxShadow": "none" }}>
                    <div>
                      <div id="feed-post-1" className="card is-post single-post-area">
                        <div className="content-wrap">
                          <div className="card-heading">
                            <div id="myDIV2">
                              {(feedDetailEdit || feedlst?.CreatedBy == userDetails?.EmpId) &&
                                <a className="dropdown-item"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => EditFeedLst(feedlst)}
                                  aria-expanded="false"
                                  data-toggle="tooltip"
                                  data-placement="right"
                                  data-bs-toggle="modal"
                                  data-bs-target="#feed-org"
                                  title="Edit">
                                  <div className="media">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil-square"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                      />
                                    </svg>
                                    <div className="media-content">
                                      <h3>Edit</h3>
                                    </div>
                                  </div>
                                </a>
                              }
                              {(feedDetailDelete || feedlst?.CreatedBy == userDetails?.EmpId) &&
                                <a style={{ cursor: 'pointer' }} className="dropdown-item" data-bs-toggle="modal" data-bs-target="#delete-post" onClick={() => deleteItem(feedlst?.Id)}>
                                  <div className="media">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                      height="16" fill="currentColor" className="bi bi-trash"
                                      viewBox="0 0 16 16" title="Delete">
                                      <path
                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                      <path fillRule="evenodd"
                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                    </svg>
                                    <div className="media-content">
                                      <h3>Delete </h3>
                                    </div>
                                  </div>
                                </a>}
                              {(feedlst?.CreatedBy != userDetails?.EmpId && feedDetailReport) && <a
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#report-img"
                                style={{ cursor: 'pointer' }}
                                onClick={() => { setShowPostModal(true); setFeedId(feedlst?.Id) }}
                              >
                                <div className="media">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-flag mr-2"
                                    title="Report"
                                  >
                                    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                                    <line x1="4" y1="22" x2="4" y2="15"></line>
                                  </svg>
                                  <div className="media-content">
                                    <h3>Report this post</h3>
                                  </div>
                                </div>
                              </a>}
                              {(feedDetailFeatured && feedLst[0]?.IsFeatured == 0) &&
                                <a style={{ cursor: 'pointer' }} className="dropdown-item" data-bs-toggle="modal" data-bs-target="#featured-post" onClick={() => markFeatured(feedlst?.Id, 1)}>
                                  <div className="media">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-check" viewBox="0 0 16 16" title="Featured">
                                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    <div className="media-content">
                                      <h3>Mark as Featured</h3>
                                    </div>
                                  </div>
                                </a>}
                              {(feedDetailFeatured && feedLst[0]?.IsFeatured === 1) && (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="dropdown-item"
                                  data-bs-toggle="modal"
                                  data-bs-target="#featured-post"
                                  onClick={() => markUnFeatured(feedlst?.Id, 2)}
                                >
                                  <div className="media">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-file-earmark-check"
                                      viewBox="0 0 16 16"
                                      title="Unfeatured"
                                    >
                                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    <div className="media-content">
                                      <h3>Mark as Unfeatured</h3>
                                    </div>
                                  </div>
                                </a>
                              )}
                            </div>
                            <Link to={`/Profile/${feedLst[0]?.PostedByGUID}`}>
                              <div className="user-block d-flex">
                                <div className="image">
                                  <LazyImage src={feedlst?.ProfilePic}
                                    data-demo-src="/images/main-body/1.jpg"
                                    data-user-popover="1" alt="" />
                                </div>
                                <div className="user-info mt-2">
                                  <a className="atag">{feedlst?.PostedBy}</a>
                                  <span className="time">{moment(feedlst?.CreatedDate).format('MMMM Do YYYY, h:mm a')}</span>
                                </div>
                              </div>
                            </Link>
                            <div className="dropdown is-spaced is-right is-neutral dropdown-trigger d-flex align-items-center" style={{ gap: "5px" }}>
                              {(feedlst?.IsFeatured == 1) && (
                                <div className="featured-star" key={index}>
                                  <img
                                    src="/images/IsFeturedImage.png"
                                    title="Featured Post"
                                    data-user-popover="1"
                                    alt=""
                                  />
                                </div>
                              )}
                              <div>
                                <div className="button" onClick={myFunction}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" strokeWidth="2"
                                    strokeLinecap="round" strokeLinejoin="round"
                                    className="feather feather-more-vertical">
                                    <circle cx="12" cy="12" r="1"></circle>
                                    <circle cx="12" cy="5" r="1"></circle>
                                    <circle cx="12" cy="19" r="1"></circle>
                                  </svg>
                                </div>
                              </div>
                              <div className="dropdown-menu" role="menu">
                                <div className="dropdown-content">
                                  <a className="dropdown-item">
                                    <div className="media">
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor"
                                        strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-bookmark">
                                        <path
                                          d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z">
                                        </path>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Bookmark</h3>
                                        <small>Add this post to your
                                          bookmarks.</small>
                                      </div>
                                    </div>
                                  </a>
                                  <a className="dropdown-item">
                                    <div className="media">
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor"
                                        strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-bell">
                                        <path
                                          d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9">
                                        </path>
                                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Notify me</h3>
                                        <small>Send me the updates.</small>
                                      </div>
                                    </div>
                                  </a>
                                  <hr className="dropdown-divider" />
                                  <a className="dropdown-item">
                                    <div className="media">
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor"
                                        strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-flag">
                                        <path
                                          d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z">
                                        </path>
                                        <line x1="4" y1="22" x2="4" y2="15"></line>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Flag</h3>
                                        <small>In case of inappropriate
                                          content.</small>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div key={index} className="card-body pb-0">
                            <FeedSliderCarousel templateData={feedlst} itemIndex={index} onPassResponse={handleEvent} />
                          </div>
                          <FeedDetailComment Feedlst={feedlst} Index={index} feedGUID={FeedGUID} onPassLikeResponse={handleLikeEvent} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>)}
          </div>
          <div className="col-xl-3 third">
            <FollowUpSuggestions EmpId={feedEmployeeDetails?.EmpId} />
            <div className="col-xl-12 owl-co owl-co2 col-sm-6">
              <div className="card award">
                <div className="card-body">
                  <div className="custom-tab-1 custom-tab-11">
                    <div className="slide22">
                      <strong className="upcome">
                        {T("Featured Posts")}
                      </strong>
                      <Link to="/Feed/Featured" className="more-icon">
                        <i className="fa fa-angle-right"></i>
                      </Link>
                      <DashboardFeatureAndPopularPost />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 owl-co owl-co2 col-sm-6">
              <div className="card award">
                <div className="card-body">
                  <div className="custom-tab-1 custom-tab-11">
                    <div className="slide22">
                      <strong className="upcome">
                        {T("Popular Posts")}
                      </strong>
                      <Link to="/Feed/Popular" className="more-icon">
                        <i className="fa fa-angle-right"></i>
                      </Link>
                      <DashboardPopularPost />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="report-img">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal" onClick={() => handalClosePopup}
              ></button>
            </div>
            <div className="modal-body text-center">
              <img src="/images/popup-icons/report.png" />
              <strong className="modal-title"> Do you sure report ?</strong>
              <form >
                <div className="form-group">
                  <div className="form-group mb-4 text-left p-0">
                    <label>Subject Name</label>
                    <input
                      type="text"
                      name="subject"
                      className={
                        "form-control" +
                        (reportPostForm.errors.subject &&
                          reportPostForm.touched.subject
                          ? " is-invalid"
                          : "")
                      }
                      onChange={reportPostForm.handleChange}
                      value={reportPostForm.values.subject}
                      placeholder="Subject Name"
                    /><div className="invalid-feedback">
                      {reportPostForm.errors.subject &&
                        reportPostForm.touched.subject
                        ? reportPostForm.errors.subject
                        : null}
                    </div>
                  </div>
                  <div className="form-group mb-4 text-left p-0">
                    <label>
                      <i className="fa fa-info-circle" aria-hidden="true"></i>{" "}
                      Help us understand what's happening.
                    </label>
                    <input
                      type="text"
                      name="desc"
                      className={
                        "form-control" +
                        (reportPostForm.errors.desc &&
                          reportPostForm.touched.desc
                          ? " is-invalid"
                          : "")
                      }
                      onChange={reportPostForm.handleChange}
                      value={reportPostForm.values.desc}
                      placeholder="Description"
                    /> <div className="invalid-feedback">
                      {reportPostForm.errors.desc &&
                        reportPostForm.touched.desc
                        ? reportPostForm.errors.desc
                        : null}
                    </div>
                  </div>
                  <div className="col-xl-5">
                    <div className="form-group mb-4 text-left">
                      <div className="upload__box">
                        {uploadedPostImages.length <= 0 && <div className="upload__btn-box">
                          <label className="d-block">
                            Upload Doc
                          </label>
                          <label className="upload__btn">
                            <p className="m-0">
                              <i className="fa fa-plus-square-o mr-3"></i>
                              Upload Doc
                            </p>
                            <input
                              type="file"
                              multiple=""
                              data-max_length="20"
                              className="upload__inputfile"
                              onChange={handleFilePostChange}
                            />
                          </label>
                        </div>}
                        {uploadedPostImages?.length != 0 && <div className="upload__img-wrap">
                          <div className="upload__img-box">
                            <span className="closeresume_Report"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteImage(uploadedPostImages)}
                              title="Delete"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="bi bi-x"
                                viewBox="0 0 16 16"
                              >
                                {" "}
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                              </svg>
                            </span>
                            <img
                              src={uploadedPostImages}
                              className="w-100"
                            />
                          </div>
                        </div>}
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </form>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="btn btn-danger light"
                  data-bs-dismiss="modal"
                  onClick={handalClosePopup}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={reportPostForm.handleSubmit}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-post">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this post? This process cannot be undone.</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => DeleteFeedPost()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="featured-post">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content featured-post-confirmation">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/popup-icons/featured-post.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>
                Do you really want to {isFeaturedType == 1 && "feature"}{" "}
                {isFeaturedType == 2 && "unfeature"} this post ?
              </p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              {(isFeaturedType == 1) && (
                <button
                  type="button"
                  className="savebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => PostMarkFeatured()}
                >
                  Feature
                </button>
              )} {(isFeaturedType == 2) && (
                <button
                  type="button"
                  className="savebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => PostMarkUnFeatured()}
                >
                  Unfeature
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
// }
export default FeedDetails;